import * as React from 'react';

import { connect } from 'react-redux';

import { FilterBase, mapDispatchToProps, mapStateToProps } from './filter-base';
import { IAppState } from '../classes/app';
import { IOption } from '../classes/input-option';
import { Console } from 'console';

export enum Sort {
    Random,
    AtoZ,
    ZtoA,
    Date,
    Recency,
    Nearest,
    Furthest
}

const SortOptionMap: { [id: number]: string } = {
    [Sort.Random]: 'Providers',
    [Sort.AtoZ]: 'A - Z',
    [Sort.ZtoA]: 'Z - A',
    [Sort.Recency]: 'Recency',
    [Sort.Nearest]: 'Nearest',
    [Sort.Furthest]: 'Furthest'
};


interface IExternalProps {
    property: string;
    title: string;
    description?: string;
    defaultOption?: IOption;
    options?: IOption[];
    sortByLocation?: boolean
}

interface StateToProps {
    options?: IOption[];
    selectedOptions?: string,
    selectedOptionText?: string,
    selectedOptionNextValue?: number
}

export class SortOptions extends FilterBase {

    get externalProps(): IExternalProps {
        return this.props;
    }

    get componentProps(): StateToProps {
        return this.props;
    }

    convertEvtToString(evt: React.MouseEvent<HTMLButtonElement>) {
        return evt.currentTarget.value
    }

    submitChange(evt: React.MouseEvent<HTMLButtonElement>) {

        this.boundFilterUpdate(this.convertEvtToString(evt), true);
    }

    toogleSort(evt: React.MouseEvent<HTMLButtonElement>) {
        if (this.componentProps.selectedOptionNextValue) {
            this.boundFilterUpdate(this.componentProps.selectedOptionNextValue, true);
        }
    }

    render() {
        return (
            <>
                {this.externalProps.sortByLocation && this.componentProps.selectedOptionText ?
                    <>
                        <div className="adage-search-results-header-sort-item">
                            <span className="adage-search-results-header-label">Sort {this.props.description} By:</span>
                            <button className="btn-text sort-trigger" onClick={this.toogleSort.bind(this)}>{this.componentProps.selectedOptionText}</button>
                        </div>
                    </>
                    :
                    <>
                        <div className="adage-search-results-header-sort-item">
                            <span className="adage-search-results-header-label">Sort {this.props.description} By:</span>
                            {

                                this.props.options.map((option, index) => {
                                    switch (parseInt(option.value)) {
                                        case Sort.AtoZ:
                                            if (parseInt(this.props.selectedOptions) != Sort.AtoZ || !this.props.selectedOptions) {
                                                return <button className="btn-text sort-trigger" key={index + option.text} onClick={this.submitChange.bind(this)} value={option.value}>{option.text}</button>
                                            } else {
                                                return <button className="btn-text hide" key={index + option.text} onClick={this.submitChange.bind(this)} value={option.value}>{option.text}</button>
                                            }
                                        case Sort.ZtoA:
                                            if (this.props.selectedOptions && parseInt(this.props.selectedOptions) == Sort.AtoZ) {
                                                return <button className="btn-text sort-trigger" key={index + option.text} onClick={this.submitChange.bind(this)} value={option.value}>{option.text}</button>
                                            } else {
                                                return <button className="btn-text hide" key={index + option.text} onClick={this.submitChange.bind(this)} value={option.value}>{option.text}</button>
                                            }
                                        default:

                                            return <button className="btn-text sort-trigger" key={index + option.text} onClick={this.submitChange.bind(this)} value={option.value}>{option.text}</button>

                                    }

                                })
                            }
                        </div>
                    </>
                }
            </>
        )
    }
}

export function sortMapStateToProps(state: IAppState, ownProps: IExternalProps): StateToProps {
    const options = state.filtersState.filterOptions[ownProps.property];

    const filterCity = state.filtersState.filters['city'];
    const filterZip = state.filtersState.filters['zip'];
    const filterAddressCityOrZip = state.filtersState.filters['AddressOrCityOrZip'];
    const selectedFilter: number = parseInt(state.filtersState.filters[ownProps.property] ? state.filtersState.filters[ownProps.property] : '1');

    let selectedOptionText = SortOptionMap[Sort.AtoZ];
    let selectedOptionNextValue = Sort.ZtoA;
    let selectedOptionsDefault = "";

    if (ownProps.sortByLocation) {
        // Has location selected.
        if (filterCity || filterZip || filterAddressCityOrZip) {
            if (selectedFilter == Sort.Furthest) {
                selectedOptionText = SortOptionMap[Sort.Nearest];
                selectedOptionNextValue = Sort.Nearest;
                selectedOptionsDefault = "6";
            }
            else {
                selectedOptionText = SortOptionMap[Sort.Furthest];
                selectedOptionNextValue = Sort.Furthest;
                selectedOptionsDefault = "5";
            }
        }
        else {
            if (selectedFilter == Sort.ZtoA) {
                selectedOptionText = SortOptionMap[Sort.AtoZ];
                selectedOptionNextValue = Sort.AtoZ;
                selectedOptionsDefault = "2";
            }
            else {
                selectedOptionText = SortOptionMap[Sort.ZtoA];
                selectedOptionNextValue = Sort.ZtoA;
                selectedOptionsDefault = "1";
            }
        }
    }
    return {
        options: options ? options.map(option => { return { text: SortOptionMap[parseInt(option)], value: option.toString() } }) : [],
        selectedOptions: state.filtersState.filters[ownProps.property] ? state.filtersState.filters[ownProps.property] : selectedOptionsDefault,
        selectedOptionText: selectedOptionText,
        selectedOptionNextValue: selectedOptionNextValue,
    }
}


export const ConnectedSort = connect(sortMapStateToProps, mapDispatchToProps)(SortOptions);